var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7_3887)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 41.5,
    fill: "url(#paint0_linear_7_3887)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6444 69.9445C35.5407 69.9445 33.0247 67.4285 33.0247 64.3248V49.9682C33.0247 48.3751 33.7008 46.8568 34.885 45.7911L47.9979 33.9895C50.1351 32.066 53.3795 32.066 55.5167 33.9895L68.6296 45.7911C69.8137 46.8568 70.4899 48.3751 70.4899 49.9682V64.3248C70.4899 67.4285 67.9739 69.9445 64.8701 69.9445H38.6444ZM66.7434 49.9682V64.3248C66.7434 65.3593 65.9047 66.198 64.8701 66.198H59.2504V56.8317C59.2504 53.728 56.7343 51.2119 53.6306 51.2119H49.884C46.7803 51.2119 44.2642 53.728 44.2642 56.8317V66.198H38.6444C37.6099 66.198 36.7712 65.3593 36.7712 64.3248V49.9682C36.7712 49.4372 36.9966 48.9311 37.3913 48.5758L50.5041 36.7743C51.2166 36.1331 52.298 36.1331 53.0104 36.7743L66.1233 48.5758C66.518 48.9311 66.7434 49.4372 66.7434 49.9682ZM48.0108 66.198V56.8317C48.0108 55.7971 48.8495 54.9584 49.884 54.9584H53.6306C54.6651 54.9584 55.5038 55.7971 55.5038 56.8317V66.198H48.0108Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2642 57.0617C44.2642 53.6994 46.99 50.9736 50.3523 50.9736H53.1622C56.5246 50.9736 59.2503 53.6994 59.2503 57.0617V65.9597H55.5038V57.0617C55.5038 55.7685 54.4554 54.7202 53.1622 54.7202H50.3523C49.0591 54.7202 48.0107 55.7685 48.0107 57.0617V65.9597H44.2642V57.0617Z",
    fill: "url(#paint1_linear_7_3887)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2642 57.0617C44.2642 53.6994 46.99 50.9736 50.3523 50.9736H53.1622C56.5246 50.9736 59.2503 53.6994 59.2503 57.0617V65.9597H55.5038V57.0617C55.5038 55.7685 54.4554 54.7202 53.1622 54.7202H50.3523C49.0591 54.7202 48.0107 55.7685 48.0107 57.0617V65.9597H44.2642V57.0617Z",
    fill: "url(#paint2_linear_7_3887)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2653 57.3C44.2653 53.9377 46.9911 51.2119 50.3534 51.2119H53.1633C56.5257 51.2119 59.2514 53.9377 59.2514 57.3V66.198H55.5049V57.3C55.5049 56.0068 54.4565 54.9584 53.1633 54.9584H50.3534C49.0602 54.9584 48.0118 56.0068 48.0118 57.3V66.198H44.2653V57.3Z",
    fill: "url(#paint3_linear_7_3887)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7_3887",
    x: 0,
    y: 0,
    width: 103,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.217094 0 0 0 0 0.765128 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_3887"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_3887",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_3887",
    x1: 51.5,
    y1: 10,
    x2: 51.5,
    y2: 93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_3887",
    x1: 57.8933,
    y1: 65.9597,
    x2: 44.4439,
    y2: 64.4915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677095,
    stopColor: "#F3D25C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7_3887",
    x1: 57.8933,
    y1: 65.9597,
    x2: 44.4439,
    y2: 64.4915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677095,
    stopColor: "#F3D25C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7_3887",
    x1: 57.8944,
    y1: 66.198,
    x2: 44.445,
    y2: 64.7297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677095,
    stopColor: "#F3D25C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map_marker.1882ee54e7354778ce0618b546f7546a.svg";
export { ForwardRef as ReactComponent };